import fetch from '../utils/fetch'


/******敬之保险相关**********/
export function saveJingzhiProduct (params) {
  return fetch({
    url: '/jingzhi/creat',
    method: 'post',
    data: params
  })
}
export function getJingzhiProductList (query) {
  return fetch({
    url: '/jingzhi/list',
    method: 'get',
    params: query
  })
}
export function updateJingzhiProduct (id, params) {
  return fetch({
    url: '/jingzhi/update/'+id,
    method: 'put',
    data: params
  })
}

export function getGoods (id) {
  return fetch({
    url: '/jingzhi/get_goods/'+id,
    method: 'put'
  })
}
export function getGoodsList (id) {
  return fetch({
    url: '/jingzhi/get_goods/list/'+id,
    method: 'put'
  })
}
export function deleteGoods (params) {
  return fetch({
    url: '/jingzhi/delete_goods',
    method: 'put',
    data: params
  })
}
export function deleteJingzhiProduct (id) {
  return fetch({
    url: '/jingzhi/delete/' + id,
    method: 'delete'
  })
}
export function getSafeinfoList (query) {
  return fetch({
    url: '/jingzhi/safeinfo',
    method: 'get',
    params: query
  })
}
/******敬之保险相关**********/




// WEBPACK FOOTER //
// ./src/api/jingzhi.js